__webpack_require__.p = "/themes/custom/studiometa/dist/";